import {randomId,View,FlatList,map,isTouchDevice} from "vritra";
import css from "./Preview.module.css";
import ItemView from "./ItemView/ItemView";


export default function Preview(props){
    const {parent,id=randomId("preview")}=props;
    const preview=View({parent,id,className:css.preview});

    preview.value

    preview.innateHTML=`
        ${isTouchDevice()?"":`
            <p class="${css.message}">You can notice how more elements are created the more you scroll</p>
            <p class="${css.message}">Use a touch device to see "smooth horizontal paging" preview. You may need to refresh the page</p>
        `}
        <div class="${css.sections}">
            ${map(statics.sections,({name})=>`
                <div data-name="${name}" class="${css.section}">
                    <h3 class="${css.title}">${name||""}</h3>
                </div>
            `)}
        </div>
    `;

    const sectionEls=preview.querySelectorAll(`.${css.section}`);
    sectionEls.forEach((sectionEl,i)=>{
        const section=statics.sections[i];
        FlatList({
            className:css.flatlist,
            threshold:0,
            ...section,
            parent:sectionEl,
            renderItem:(props)=>{
                const {getItemProps}=section;
                if(getItemProps){
                    Object.assign(props,getItemProps(props));
                }
                return ItemView(props);
            },
            containerClassName:`${css.container} ${section.containerClassName||""}`,
            data:new Array(15).fill().map((_,i)=>({})),
        });

    });

    return preview;
}

const statics={
    sections:[
        {
            name:"default",
        },
        isTouchDevice()&&{
            name:"smooth horizontal paging",
            className:css.horizontallist,
            containerClassName:css.horizontalcontainer,
            horizontal:true,
            pagingEnabled:true,
            smoothPaging:true,
            threshold:undefined,
            getItemProps:()=>({
                className:css.horizontalitem,
            }),
        },
        {
            name:"backwards",
            backwards:true,
        },
    ].filter(Boolean),
}
